var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlackTwitterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.9817 15.9057L25.5384 8.28394H23.9846L18.2915 14.9018L13.7443 8.28394H8.49976L15.3759 18.2913L8.49976 26.2839H10.0536L16.0657 19.2952L20.8678 26.2839H26.1124L18.9813 15.9057H18.9817ZM16.8535 18.3795L16.1568 17.383L10.6134 9.45365H13L17.4736 15.8529L18.1703 16.8494L23.9854 25.1674H21.5988L16.8535 18.3799V18.3795Z",
  fill: "#001246"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 0.78418,
  width: 33,
  height: 33,
  rx: 16.5,
  stroke: "black"
})));
export default SvgBlackTwitterIcon;